<!-- PARÁMETROS → BANDAS DE APROBACIÓN (4.6c; maqueta vistas 11 y 12). Estilo de la casa; sin diálogos. -->
<div class="kb-page kb-liq">
  <nav class="kb-migas" aria-label="Migas">
    <a class="kb-miga" routerLink="/console/parametros-sistema">Parámetros del sistema</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <a class="kb-miga" routerLink="/console/parametros-sistema/liquidacion">Liquidación a comercios</a>
    <i class="fas fa-chevron-right kb-miga-sep" aria-hidden="true"></i>
    <span class="kb-miga-actual">Bandas de aprobación</span>
  </nav>

  <div class="kb-page-header">
    <div class="max-w-[720px]">
      <h1 class="kb-page-title flex items-center gap-2.5"><i class="fas fa-sliders-h text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Bandas de aprobación</h1>
      <p class="kb-page-meta">Quién aprueba cada tanda de liquidación según su monto, con una o dos firmas en orden. Una versión
        nueva la propone la gerente, la aprueba el director y rige desde su fecha. Cada tanda guarda con qué versión se aprobó.</p>
    </div>
    <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90 shrink-0"
            *ngIf="puedeProponer && !nueva && !cargando && !propuestas.length" (click)="empezar()">
      <i class="fas fa-plus" aria-hidden="true"></i>Proponer una versión nueva
    </button>
  </div>

  <div class="kb-aviso kb-aviso-peligro" *ngIf="error" role="alert"><i class="fas fa-exclamation-circle mt-0.5" aria-hidden="true"></i><div><p class="m-0">{{ error }}</p></div></div>
  <div class="kb-cinta kb-cinta-info" *ngIf="aviso" role="status"><i class="fas fa-check-circle kb-cinta-icono" aria-hidden="true"></i><span>{{ aviso }}</span></div>
  <p class="kb-hint" *ngIf="cargando">Cargando las bandas…</p>

  <!-- Vigente -->
  <section class="kb-card" *ngIf="!cargando">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-check-circle text-muted-foreground" aria-hidden="true"></i>Vigente{{ vigente ? ' · ' + vigente.code : '' }}</h2>
        <p class="kb-card-desc" *ngIf="vigente">Rige desde el {{ fecha(vigente.desde) }}. Los rangos son de ejemplo hasta que Ángela defina los reales (P24).</p>
        <p class="kb-card-desc" *ngIf="!vigente">No hay ninguna versión aprobada: hasta que la haya, no se envían tandas.</p>
      </div>
      <span class="kb-badge kb-badge-exito" *ngIf="vigente"><i class="fas fa-check-circle" aria-hidden="true"></i>Vigente</span>
    </div>
    <div class="kb-table-envoltorio" *ngIf="vigente">
      <table class="kb-table">
        <thead class="kb-thead"><tr><th class="kb-th">Banda</th><th class="kb-th">Monto de la tanda</th><th class="kb-th">Quién firma, en orden</th></tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let b of vigente.bandas; let i = index">
            <td class="kb-td kb-td-titulo">Banda {{ i + 1 }}</td><td class="kb-td tabular-nums">{{ rango(vigente.bandas, i) }}</td><td class="kb-td">{{ firmas(b) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- Versión nueva (la gerente) -->
  <section class="kb-card" *ngIf="nueva">
    <div class="kb-card-header"><div>
      <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-code-branch text-muted-foreground" aria-hidden="true"></i>Versión nueva</h2>
      <p class="kb-card-desc">Arranca con la vigente: cambia los topes y quién firma. La última banda no tiene tope.</p>
    </div></div>
    <div class="kb-card-body flex flex-col gap-[16px]">
      <div class="grid max-w-2xl grid-cols-1 gap-4 sm:grid-cols-[180px_minmax(0,1fr)]">
        <div><label class="kb-label" for="bDesde">Rige desde</label><input id="bDesde" type="date" class="kb-input" [(ngModel)]="nueva.desde" name="bDesde"></div>
        <div><label class="kb-label" for="bMotivo">Motivo</label><input id="bMotivo" type="text" class="kb-input" [(ngModel)]="nueva.motivo" name="bMotivo" placeholder="p. ej. rangos definitivos de Ángela"></div>
      </div>
    </div>
    <div class="kb-table-envoltorio">
      <table class="kb-table">
        <thead class="kb-thead"><tr><th class="kb-th">Banda</th><th class="kb-th">Tope (USD)</th><th class="kb-th">Primera firma</th><th class="kb-th">Segunda firma</th><th class="kb-th kb-th-acciones"><span class="sr-only">Quitar</span></th></tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let b of nueva.bandas; let i = index; let ultima = last">
            <td class="kb-td kb-td-titulo">Banda {{ i + 1 }}</td>
            <td class="kb-td">
              <input *ngIf="!ultima" type="number" min="1" step="100" class="kb-input !w-[140px] text-right tabular-nums" [(ngModel)]="b.hasta" [name]="'tope' + i" [attr.aria-label]="'Tope de la banda ' + (i + 1)">
              <span class="kb-td-sub" *ngIf="ultima">sin tope</span>
            </td>
            <td class="kb-td">
              <div class="kb-select-envoltorio !w-[200px]"><select class="kb-select" [(ngModel)]="b.f0" [name]="'f0' + i" [attr.aria-label]="'Primera firma de la banda ' + (i + 1)">
                <option *ngFor="let r of ROLES" [value]="r.v">{{ r.t }}</option></select><i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i></div>
            </td>
            <td class="kb-td">
              <div class="kb-select-envoltorio !w-[220px]"><select class="kb-select" [(ngModel)]="b.f1" [name]="'f1' + i" [attr.aria-label]="'Segunda firma de la banda ' + (i + 1)">
                <option value="">— sin segunda firma</option>
                <option *ngFor="let r of ROLES" [value]="r.v">y luego {{ r.t }}</option></select><i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i></div>
            </td>
            <td class="kb-td kb-td-acciones">
              <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm" *ngIf="!ultima && nueva.bandas.length > 2" (click)="quitarBanda(i)" [attr.aria-label]="'Quitar la banda ' + (i + 1)"><i class="fas fa-times !text-muted-foreground" aria-hidden="true"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="kb-card-footer flex-wrap gap-3">
      <button type="button" class="kb-btn kb-btn-ghost mr-auto" (click)="agregarBanda()"><i class="fas fa-plus !text-muted-foreground" aria-hidden="true"></i>Agregar una banda</button>
      <button type="button" class="kb-btn kb-btn-ghost" (click)="nueva = null">Cancelar</button>
      <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90" [disabled]="enviando" (click)="enviar()">
        <i class="fas fa-paper-plane" aria-hidden="true"></i>{{ enviando ? 'Enviando…' : 'Enviar a aprobación del director' }}
      </button>
    </div>
  </section>

  <!-- Por aprobar (el director): antes → ahora -->
  <section class="kb-card" *ngFor="let v of propuestas">
    <div class="kb-card-header">
      <div>
        <h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-sliders-h text-muted-foreground" aria-hidden="true"></i>{{ v.code }} · propuesta</h2>
        <p class="kb-card-desc">Rige desde el {{ fecha(v.desde) }} si se aprueba · reemplaza a {{ anterior(v)?.code || 'ninguna' }}{{ v.motivo ? ' · ' + v.motivo : '' }}</p>
      </div>
      <span class="kb-badge kb-badge-alerta">Por aprobar</span>
    </div>
    <div class="kb-table-envoltorio">
      <table class="kb-table">
        <thead class="kb-thead"><tr><th class="kb-th">Banda</th><th class="kb-th">Monto de la tanda</th><th class="kb-th">Quién firma</th><th class="kb-th">Cambio</th></tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let b of v.bandas; let i = index">
            <td class="kb-td kb-td-titulo">Banda {{ i + 1 }}</td>
            <td class="kb-td tabular-nums">
              <span class="kb-td-sub block line-through" *ngIf="cambia(v, i) && anterior(v)?.bandas?.[i] && rango(anterior(v).bandas, i) !== rango(v.bandas, i)">{{ rango(anterior(v).bandas, i) }}</span>{{ rango(v.bandas, i) }}
            </td>
            <td class="kb-td">
              <span class="kb-td-sub block line-through" *ngIf="cambia(v, i) && anterior(v)?.bandas?.[i] && firmas(anterior(v).bandas[i]) !== firmas(b)">{{ firmas(anterior(v).bandas[i]) }}</span>{{ firmas(b) }}
            </td>
            <td class="kb-td"><span class="kb-badge kb-badge-alerta" *ngIf="cambia(v, i)">Cambia</span><span class="kb-td-sub" *ngIf="!cambia(v, i)">Igual</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="kb-card-footer flex-wrap gap-3" *ngIf="puedeAprobar && devolviendo !== v.code">
      <span class="mr-auto text-sm text-muted-foreground">Las tandas ya aprobadas siguen con la versión con que se aprobaron.</span>
      <button type="button" class="kb-btn kb-btn-outline" (click)="devolviendo = v.code; observacion = ''">Devolver con observación</button>
      <button type="button" class="kb-btn kb-btn-primary !bg-foreground !text-background hover:!bg-foreground/90" (click)="aprobar(v)"><i class="fas fa-check" aria-hidden="true"></i>Aprobar {{ v.code }}</button>
    </div>
    <div class="kb-card-footer flex-wrap items-end gap-3" *ngIf="puedeAprobar && devolviendo === v.code">
      <div class="mr-auto min-w-[260px] flex-1"><label class="kb-label" for="bObservacion">Observación para la gerente</label>
        <input id="bObservacion" type="text" class="kb-input" [(ngModel)]="observacion" name="bObservacion"></div>
      <button type="button" class="kb-btn kb-btn-ghost" (click)="devolviendo = null">Cancelar</button>
      <button type="button" class="kb-btn kb-btn-outline" (click)="devolver(v)">Devolver</button>
    </div>
    <div class="kb-card-footer" *ngIf="!puedeAprobar"><span class="mr-auto text-sm text-muted-foreground">Esperando la aprobación del director.</span></div>
  </section>

  <!-- Historial -->
  <section class="kb-card" *ngIf="versiones.length">
    <div class="kb-card-header"><div><h2 class="kb-card-title flex items-center gap-2"><i class="fas fa-history text-muted-foreground" aria-hidden="true"></i>Historial</h2></div></div>
    <div class="kb-table-envoltorio">
      <table class="kb-table">
        <thead class="kb-thead"><tr><th class="kb-th">Versión</th><th class="kb-th">Rige desde</th><th class="kb-th">Estado</th><th class="kb-th">Nota</th></tr></thead>
        <tbody>
          <tr class="kb-tr" *ngFor="let v of versiones">
            <td class="kb-td font-mono text-xs">{{ v.code }}</td><td class="kb-td tabular-nums">{{ fecha(v.desde) }}</td>
            <td class="kb-td"><span class="kb-badge" [ngClass]="estado(v).c">{{ estado(v).t }}</span></td>
            <td class="kb-td"><span class="kb-td-sub">{{ v.devuelta_motivo || v.motivo || '' }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</div>
